import React from 'react'
import ExtractSignatureComponent from '../components/shifts.component'

function ExtractSignatureContainer() {
  return <ExtractSignatureComponent />
}

export default ExtractSignatureContainer
